export interface Insets {
  top: number;
  right: number;
  bottom: number;
  left: number;
}

/** Resolve the iOS safe-area insets (notch / home indicator) in CSS px, read
 *  from the #safe-area-probe element's env()-based padding. */
export function getSafeInsets(): Insets {
  const el = document.getElementById('safe-area-probe');
  if (!el) return { top: 0, right: 0, bottom: 0, left: 0 };
  const s = getComputedStyle(el);
  const n = (v: string): number => parseFloat(v) || 0;
  return {
    top: n(s.paddingTop),
    right: n(s.paddingRight),
    bottom: n(s.paddingBottom),
    left: n(s.paddingLeft),
  };
}
